import { Sparkles } from "lucide-react";

export const FanBadge = ({ story, className = "" }) => {
  if (!story?.fan_work) return null;
  return (
    <div className={`flex flex-wrap items-center gap-1.5 text-xs text-[#C9BFAE] ${className}`} data-testid={`fan-work-badge-${story.id}`}>
      <span className="inline-flex items-center gap-1 rounded-full border border-[#8B5CF6]/40 bg-[#8B5CF6]/10 px-2 py-0.5 text-[10px] uppercase tracking-widest text-[#C4B5FD]"><Sparkles className="h-3 w-3" />Fan work</span>
      {story.fan_source && <span className="[overflow-wrap:anywhere]" data-testid={`fan-work-source-${story.id}`}>Based on {story.fan_source}</span>}
    </div>
  );
};
